import { Button, Dialog } from '@/components/UI'
import { useTranslation } from 'react-i18next'

type Props = {
  /** ダイアログの表示状態 */
  opened: boolean
  /** OK ボタン押下時 */
  onClose: () => void
}

export const DialogCouponUsed = ({ opened, onClose }: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog selectorState={opened} closeFunc={onClose} showCloseButton={false}>
      <div data-testid="dialog-coupon-used">
        {/* タイトル */}
        <div className="flex h-[44px] items-center justify-center">
          <h2 className="text-[16px] font-bold leading-[24px] text-black">
            {t('coupon.used_title', 'クーポンを使用しました')}
          </h2>
        </div>

        {/* OK ボタン */}
        <div className="mt-4 flex justify-center">
          <Button label={t('common.ok', 'OK')} variant="primary" size="md" onClick={onClose} fullWidth />
        </div>
      </div>
    </Dialog>
  )
}
